import Api, {
  baseURL,
  requestOptionsGET,
  requestOptionsDELETEWithArrayBody,
  requestOptionsPOSTWithArrayBody
} from '../api';
import newFetch from '../utils/newFetch';

const state = {
  xmlsNfe: [],
  paginate: {
    pageNumber: 1,
    pageSize: 5,
    totalRecords: 0,
    totalPages: 0
  },
  filters: {
    filterByStatusId: null
  }
};

const getters = {
  getXmlsNfe: (state) => state.xmlsNfe,
  getFilters: ({ paginate, filters }) => {
    return (
      `&PageSize=${paginate.pageSize}&PageNumber=${paginate.pageNumber}` +
      (filters.filterByStatusId ? `&StatusId=${filters.filterByStatusId}` : '')
    );
  }
};

const mutations = {
  setXmlsNfeByid(state, payload) {
    state.xmlsNfe = payload;
  },
  setItemPerPage(state, payload) {
    state.paginate.pageSize = payload;
  },
  setPageNumber(state, payload) {
    state.paginate.pageNumber = payload;
  },
  setTotalPages(state, payload) {
    state.paginate.totalPages = payload;
  },
  setTotalRecords(state, payload) {
    state.paginate.totalRecords = payload;
  },
  setFilterStatusId(state, payload) {
    state.filters.filterByStatusId = payload;
  }
};

const actions = {
  uploadXmlNfe(_, payload) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.uploadNfeXml,
        requestOptionsPOSTWithArrayBody(localStorage.getItem('accessToken'), payload)
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getUnusedNfes() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getUnusedNfes, requestOptionsGET(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  getAllXmlsNfe(context, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getAllXmlsNfe + id + context.getters.getFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setXmlsNfeByid', data);
          context.commit('setTotalPages', totalPages);
          context.commit('setTotalRecords', totalRecords);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  getQuantityXmlsNfeStatus(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getQuantityXmlsNfeStatus + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  deleteXmlNfe(_, ids) {
    const body = ids || [];
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.deleteXmlNfe, requestOptionsDELETEWithArrayBody(localStorage.getItem('accessToken'), body))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  },
  deleteUnusedNfes(_, ids) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.deleteMultipleUnusedNfes,
        requestOptionsDELETEWithArrayBody(localStorage.getItem('accessToken'), { nfesIds: ids })
      )
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
